import React from 'react';
import { Link } from 'react-router-dom';
import './PackageBuilderPreview.css';

const TEAM_ADVENTURE_URL =
  '/quote-builder?n=25&pp=125&venue=activity-location&v=denver-bad-axe-throwing&food=mhc-fajita-bar';

const PackageBuilderPreview = () => (
  <section
    className="tw-builder-promo"
    aria-labelledby="tw-builder-promo-heading"
  >
    <div className="tw-builder-promo-inner">
      <div className="tw-builder-promo-card">
        <Link
          to="/quote-builder"
          className="tw-builder-preview tw-builder-preview-link"
          aria-label="Open the Denver package builder"
        >
          <div className="tw-builder-preview-toolbar">
            <span>Build your full event</span>
            <span>Denver</span>
          </div>

          <div className="tw-builder-preview-subtitle">
            Experience + venue + food + planning
          </div>

          <div className="tw-builder-preview-panel">
            <div className="tw-builder-preview-section-heading">
              <span className="tw-builder-preview-badge">01</span>
              <strong>Your package</strong>
            </div>

            <div className="tw-builder-preview-control-card">
              <div className="tw-builder-preview-control-row">
                <div>
                  <span className="tw-builder-preview-label">How many people?</span>
                  <strong>25 people</strong>
                </div>
                <span className="tw-builder-preview-value">25</span>
              </div>
              <div className="tw-builder-preview-slider">
                <span className="tw-builder-preview-slider-fill" />
                <span className="tw-builder-preview-slider-thumb" />
              </div>
              <div className="tw-builder-preview-slider-meta">
                <span>5</span>
                <span>200+</span>
              </div>
            </div>

            <div className="tw-builder-preview-package-list">
              <div className="tw-builder-preview-choice-row">
                <div>
                  <span className="tw-builder-preview-label">Venue</span>
                  <strong>At the activity location</strong>
                </div>
                <span className="tw-builder-preview-check">✓</span>
              </div>

              <div className="tw-builder-preview-choice-row">
                <div>
                  <span className="tw-builder-preview-label">Experience</span>
                  <strong>Bad Axe Throwing</strong>
                </div>
                <span className="tw-builder-preview-check">✓</span>
              </div>

              <div className="tw-builder-preview-choice-row">
                <div>
                  <span className="tw-builder-preview-label">Food &amp; drinks</span>
                  <strong>Fajita Bar Catering</strong>
                </div>
                <span className="tw-builder-preview-check">✓</span>
              </div>
            </div>

            <div className="tw-builder-preview-budget-card">
              <div>
                <span className="tw-builder-preview-label">Planning target</span>
                <strong>$125 / person</strong>
              </div>
              <div className="tw-builder-preview-budget-total">
                <span>Estimated total</span>
                <strong>$3,125</strong>
              </div>
            </div>
          </div>

          <span className="tw-builder-preview-open" aria-hidden="true">
            Open builder <span>→</span>
          </span>
        </Link>

        <div className="tw-builder-promo-copy">
          <p className="tw-builder-promo-kicker">
            Denver package builder
          </p>
          <h2 id="tw-builder-promo-heading">
            See what your team event could cost—in about 2 minutes.
          </h2>
          <p className="tw-builder-promo-description">
            Choose a venue, experience, food, and support. See your
            estimated budget update as you go.
          </p>

          <Link to={TEAM_ADVENTURE_URL} className="tw-builder-popular-card">
            <span className="tw-builder-popular-label">Popular starting point</span>
            <span className="tw-builder-popular-title">
              Denver Team Adventure Day
            </span>
            <span className="tw-builder-popular-price">
              From about $125/person <span aria-hidden="true">→</span>
            </span>
          </Link>

          <div className="tw-builder-promo-actions">
            <Link to="/quote-builder" className="tw-builder-promo-button">
              Build a Package
            </Link>
            <p className="tw-builder-promo-help">
              Rather have us plan it?{' '}
              <Link to="/planning-assistance">
                Get planning help <span aria-hidden="true">→</span>
              </Link>
            </p>
          </div>

          <div className="tw-builder-promo-footer">
            <p>
              Planning in Casper?{' '}
              <Link to="/planning-assistance">
                Plan a Casper Event <span aria-hidden="true">→</span>
              </Link>
            </p>
            <p className="tw-builder-promo-disclaimer">
              Final pricing is confirmed before booking.
            </p>
          </div>
        </div>
      </div>
    </div>
  </section>
);

export default PackageBuilderPreview;
